export default {
  portal_menus: {
    name: '',
    fields: {
      order: 'ลำดับ',
      image_desktop: 'รูป (Desktop)',
      image_mobile: 'รูป (Mobile)',
      target_url: 'URL',
    },
  },
}
